import React from 'react'
import AwsConfig from '../../Config/AwsConfig'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import { KTColors } from '../Constants/KTColors'

const DynamicButtonView = (props) => {
  const {
    category = '',
    urlType = '',
    linkText = '',
    linkSubText = '',
    linkAvatar = '',
    buttonPositionFromTop = '',
    buttonPositionFromLeft = '',
    pageLink = '',
    peopleLink = '',
    listLink = '',
    collectionLink = '',
    videoLink = '',
    contentLink = '',
    playstoreLink = '',
    appstoreLink = '',
    saavnLink = '',
    gaanaLink = '',
    httpsLink = '',
    buttonStyle = '',
  } = props?.contentNewLinkDetails || ''
  console.log(props.contentNewLinkDetails, 'props.contentNewLinkDetails===')

  const urltype = urlType && urlType.toLocaleLowerCase()

  const redirectButton = () => {
    switch (urltype) {
      case 'page':
        alert('Can redirect to page')
        break
      case 'people':
        alert('Can redirect to people')
        break
      case 'list':
        alert('Can redirect to list')
        break
      case 'collection':
        alert('Can redirect to collection')
        break
      case 'content':
        alert('Can redirect to content')
        break
      case 'video':
        alert('Can redirect to video')
        break
      case 'saavnlink':
        alert('Can redirect to saavnLink')
        break
      case 'gaanalink':
        alert('Can redirect to gaanaLink')
        break
      case 'storelink':
        alert('Can redirect to storeLink')
        break
      case 'httpslink':
        alert('Can redirect to httpsLink')
        break
      default:
        return ''
    }
  }

  return (
    <div>
      {buttonStyle == 'default' ? (
        <div
          class='row'
          style={{
            top: heightPercentageToDP(`${buttonPositionFromTop}`),
            left: widthPercentageToDP(`${buttonPositionFromLeft}`),
            borderRadius: widthPercentageToDP('1%'),
            position: 'absolute',
            borderWidth: 1,
            borderColor: KTColors.white80,
            backgroundColor: KTColors.black30,
          }}
          onClick={() => redirectButton()}
        >
          {linkAvatar ? (
            <div
              class='col-md-2'
              style={{
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'center',
                top: '50%',
                bottom: '50%',
                marginRight: widthPercentageToDP('3'),
              }}
            >
              <img
                src={AwsConfig.cdn_url + linkAvatar}
                style={{
                  width: widthPercentageToDP('8'),
                  height: widthPercentageToDP('8'),
                  borderRadius: widthPercentageToDP('10'),
                  backgroundColor: KTColors.black,
                }}
              />
            </div>
          ) : null}
          <div class='col'>
            <div>
              <text
                style={{
                  color: KTColors.white,
                  fontSize: heightPercentageToDP('2.2'),
                }}
              >
                {linkText}
              </text>
            </div>
            {linkSubText ? (
              <div>
                <text
                  style={{
                    color: KTColors.white,
                    fontSize: heightPercentageToDP('1.6'),
                  }}
                >
                  {linkSubText}
                </text>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div
          style={{
            top: heightPercentageToDP(`${buttonPositionFromTop}`),
            left: widthPercentageToDP(`${buttonPositionFromLeft}`),
            position: 'absolute',
          }}
        >
          <a
            href={linkText}
            target='_blank'
            style={{
              color: KTColors.blue700,
            }}
          >
            {linkText}
          </a>
        </div>
      )}
    </div>
  )
}

export default DynamicButtonView
